/** `SfProgressButton` des Excel-Exports — ohne Beschriftung, nur Symbol. */

import { ProgressButton } from '@/components/ui';

export interface ExcelExportButtonProps {
  /** Pendant zu `EnableProgress="@ExcelExportRunning"`. */
  running: boolean;
  onClick(): void | Promise<void>;
}

export function ExcelExportButton(props: ExcelExportButtonProps) {
  return (
    <ProgressButton
      title="Export to Excel"
      progress={props.running}
      iconClass="e-icons e-export-excel-2"
      onClick={() => props.onClick()}
    />
  );
}

export default ExcelExportButton;
